import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useRef, useState } from "react";
import { API } from "../api";
import { BlogsSlider } from "../Slider/BlogsSlider";
import "./about.css";
import { AboutOurPeople } from "./AboutOurPeople";
import Expertise from "./Expertise";
import { useNavigate } from "react-router-dom";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const About = () => {
  const pathRef = useRef(null);
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const navigation = useNavigate();
  // Fetch about data from API
  const fetchAboutData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/about-us`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch about data");
      }

      const data = await response.json();
      setAboutData(data.payload);
    } catch (error) {
      console.error("Error fetching about data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get media URL
  const getMediaUrl = (imageData) => {
    if (!imageData || !imageData.id) return "";
    return `${API}/api/media/${imageData.id}`;
  };

  useEffect(() => {
    fetchAboutData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // SVG Path Animation
  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    const pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    const animatePath = () => {
      path.style.transition = "stroke-dashoffset 5s ease-in-out";
      path.style.strokeDashoffset = "0";

      setTimeout(() => {
        // Reset animation
        path.style.transition = "none";
        path.style.strokeDashoffset = pathLength;

        // Small delay before restarting
        setTimeout(() => {
          path.style.transition = "stroke-dashoffset 5s ease-in-out";
          path.style.strokeDashoffset = "0";
        }, 100);
      }, 5000);
    };

    // Run animation loop continuously, regardless of visibility
    const interval = setInterval(animatePath, 7000); // 5s animation + 3s delay

    animatePath(); // Start immediately

    return () => clearInterval(interval); // Cleanup on unmount
  }, [pathRef.current]);

  const openModal = (person) => {
    setModalContent(person);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && !aboutData) {
    return (
      <div className="alert alert-warning m-3" role="alert">
        Error loading about data: {error}
      </div>
    );
  }

  // Safe data access with fallbacks
  const {
    heroSection = {},
    expertiseSection = [],
    ceoSection = {},
    visionSection = {},
    missionSection = {},
    coreValues = {},
    managementBoard = {},
    extendedTeam = {},
    productTeam = {},
    operationsTeam = {},
    HRCompliances = {},
  } = aboutData || {};

  const safeHeroSection = {
    title: heroSection.title || "About Us",
    heading1: heroSection.heading1 || "Managing Wealth with",
    heading2: heroSection.heading2 || "Precision and Purpose",
    description:
      heroSection.description ||
      "Founded on the principles of precision and purpose, Ladderup combines time-tested financial wisdom with modern insights.",
    buttonText: heroSection.buttonText || "Read More",
  };

  const safeExpertiseSection = expertiseSection || [];

  const safeCeoSection = {
    title1: ceoSection.title1 || "WHAT OUR",
    title2: ceoSection.title2 || "CEO SAYS",
    paragraphs: ceoSection.paragraphs || [],
    name: ceoSection.name || "Raghvendra Nath",
    designation: ceoSection.designation || "MD and CEO, Ladderup",
    image: ceoSection.image || { src: require("../../Images/RM.png") },
  };

  const safeVisionSection = {
    title: visionSection.title || "OUR VISION",
    description:
      visionSection.description ||
      "To be India's most trusted wealth management firm.",
  };

  const safeMissionSection = {
    title: missionSection.title || "OUR MISSION",
    description:
      missionSection.description ||
      "To preserve and grow investor wealth through smart asset allocation.",
  };

  const safeCoreValues = {
    title1: coreValues.title1 || "Our",
    title2: coreValues.title2 || "Core Values",
    description:
      coreValues.description ||
      "We're always looking for talented individuals who share our passion for innovation and excellence.",
    values: coreValues.values || [],
  };

  const safeManagementBoard = {
    titleSmall: managementBoard.titleSmall || "Our People",
    titleLarge: {
      text: managementBoard.titleLarge?.text || "Management ",
      highlight: managementBoard.titleLarge?.highlight || "Board",
    },
    description:
      managementBoard.description ||
      "The Management Board manages the company's affairs with a clear strategic vision.",
    role: managementBoard.role || "managementBoard",
    teams: managementBoard.teams || [],
  };

  const safeExtendedTeam = {
    titleSmall: extendedTeam.titleSmall || "Our People",
    titleLarge: {
      text: extendedTeam.titleLarge?.text || "Extended",
      highlight: extendedTeam.titleLarge?.highlight || "Team",
    },
    description:
      extendedTeam.description ||
      "The Extended Team brings deep industry experience and specialized expertise.",
    role: extendedTeam.role || "extendedTeam",
    teams: extendedTeam.teams || [],
  };

  const safeProductTeam = {
    titleSmall: productTeam.titleSmall || "Our People",
    titleLarge: {
      text: productTeam.titleLarge?.text || "Product",
      highlight: productTeam.titleLarge?.highlight || "Team",
    },
    description:
      productTeam.description ||
      "The Product Team focuses on developing innovative financial solutions.",
    role: productTeam.role || "productTeam",
    teams: productTeam.teams || [],
  };

  const safeOperationsTeam = {
    titleSmall: operationsTeam.titleSmall || "Our People",
    titleLarge: {
      text: operationsTeam.titleLarge?.text || "Operations",
      highlight: operationsTeam.titleLarge?.highlight || "Team",
    },
    description:
      operationsTeam.description ||
      "The Operations Team ensures smooth business operations and client servicing.",
    role: operationsTeam.role || "operationsTeam",
    teams: operationsTeam.teams || [],
  };

  const safeHRCompliances = {
    titleSmall: HRCompliances.titleSmall || "Our People",
    titleLarge: {
      text: HRCompliances.titleLarge?.text || "HR+",
      highlight: HRCompliances.titleLarge?.highlight || "Compliances",
    },
    description:
      HRCompliances.description ||
      "The HR & Compliances team manages human resources and regulatory compliance.",
    role: HRCompliances.role || "HRCompliances",
    teams: HRCompliances.teams || [],
  };

  const hendaleButtonClick = () => {
    navigation("/our-product");
  };
  return (
    <div>
      {/* Hero Section */}
      <div className="row m-0 p-0 pageBg">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div className="col-11 text-start" data-aos="zoom-in-up">
            <p className="fs-5">{safeHeroSection.title}</p>
            <p className="fs-1 line-height-1 mt-2">
              {safeHeroSection.heading1}
            </p>
            <p className="fs-1 org fw-bold">{safeHeroSection.heading2}</p>
            <p className="tJustify">{safeHeroSection.description}</p>
            <button
              className="buttonEffect mb-2"
              onClick={() => hendaleButtonClick()}
            >
              {safeHeroSection.buttonText}
            </button>
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-end justify-content-end">
          <div class="col-md-10 col-12">
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="auto"
              viewBox="0 0 869 832"
              fill="none"
              class="mt-4"
            >
              <path
                ref={pathRef}
                id="myPath"
                d="M35.5 832V627.5H232V427H446.5V233H651.5V35H868.5"
                stroke="#F47024"
                strokeWidth="70"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Expertise Section */}
      <div className="mt-5">
        <Expertise data={safeExpertiseSection} />
      </div>

      {/* CEO Section */}
      <div className="sectionBg1 row m-0">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div className="col-xxl-4 col-sm-8 mx-auto">
            <br />
            <br />
            <img
              data-aos="zoom-fade-up"
              src={
                safeCeoSection.image.id
                  ? getMediaUrl(safeCeoSection.image)
                  : safeCeoSection.image.src
              }
              className="RMImage"
              alt="CEO"
              loading="lazy"
              crossOrigin="anonymous"
            />
          </div>
        </div>
        <div className="col-md-6">
          <br />
          <div className="col-11 m-auto text-start">
            <p data-aos="fade-up" className="fs-1 line-height-1 mt-2">
              {safeCeoSection.title1}
            </p>
            <p
              data-aos="fade-up"
              className="fs-1 fw-bold org line-height-1 mb-2"
            >
              {safeCeoSection.title2}
            </p>
            {safeCeoSection.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                data-aos="fade-up"
                className="fs-5 tJustify mt-4"
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
            ))}
            <p data-aos="fade-up" className="fw-bold mt-2">
              {safeCeoSection.name}
            </p>
            <p data-aos="fade-up">{safeCeoSection.designation}</p>
          </div>
          <br />
        </div>
      </div>

      {/* Vision Section */}
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "50vh" }}
      >
        <div>
          <p className="middionText fw-bold">{safeVisionSection.title}</p>
          <p className="tJustify col-lg-6 col-11 m-auto fs-4 fw-semibold org">
            {safeVisionSection.description}
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "50vh" }}
      >
        <div>
          <p className="middionText fw-bold line-height-1">
            {safeMissionSection.title}
          </p>
          <p className="tJustify col-lg-6 col-11 m-auto fs-4 fw-semibold org">
            {safeMissionSection.description}
          </p>
        </div>
      </div>

      {/* Core Values Section */}
      <div className="row m-0 my-5 ">
        <div className="col-lg-6 joinTeamtext">
          <div className="col-11 my-4 m-auto text-start" data-aos="fade-up">
            <p className="fs-1 fw-bold line-height-1 mt-2">
              {safeCoreValues.title1}
            </p>
            <p className="fs-1 fw-bold org line-height-1 mb-2">
              {safeCoreValues.title2}
            </p>
            <p className="tJustify fs-5">{safeCoreValues.description}</p>
          </div>
        </div>
        <div className="col-lg-6 bg-dark">
          {safeCoreValues.values.map((value, index) => (
            <div
              key={index}
              className="col-11 m-auto bg-white p-3 mt-3 text-start"
            >
              <p className="fs-3 fw-bold">{value.title}</p>
              <p className="">{value.desc}</p>
            </div>
          ))}
          <br />
        </div>
      </div>

      {/* Teams Section - Only show if there's team data */}
      <div className="mt-4">
        <div className="col-11 m-auto d-md-flex">
          <div className="col-3 text-start">
            <p className="fs-5" data-aos="fade-up">
              {safeManagementBoard.titleSmall}
            </p>
            <p className="fs-1 fw-semibold" data-aos="fade-up">
              {safeManagementBoard.titleLarge.text}{" "}
              <span className="org">
                {safeManagementBoard.titleLarge.highlight}
              </span>
            </p>
          </div>
          <div
            className="col-12 col-md-8 d-flex align-items-center"
            data-aos="fade-up"
          >
            <p className="d-flex gap-3 fs-5 fs-md-4 text-start">
              {safeManagementBoard.description}
            </p>
          </div>
        </div>
        <div data-aos="fade-up">
          <AboutOurPeople
            managementBoard={safeManagementBoard}
            productTeam={safeProductTeam}
            extendedTeam={safeExtendedTeam}
            operationsTeam={safeOperationsTeam}
            HRCompliances={safeHRCompliances}
            openModal={openModal}
            getMediaUrl={getMediaUrl}
          />
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <div className="modal-body-content">
              <div className="modal-header">
                <img
                  src={
                    modalContent.imageUrl
                      ? getMediaUrl(modalContent.imageUrl)
                      : modalContent.imageUrl
                  }
                  alt={modalContent.name}
                  loading="lazy"
                  className="modal-image"
                  crossOrigin="anonymous"
                />
                <div className="modal-header-text">
                  <h3 className="modal-name fs-md-1">{modalContent.name}</h3>
                  <p className="modal-title fs-md-4">{modalContent.title}</p>
                </div>
              </div>
              <p className="modal-description text-start fs-md-5">
                {modalContent.description}
              </p>
              {modalContent.linkedinUrl && (
                <a
                  href={modalContent.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  <img
                    src="https://img.icons8.com/color/48/000000/linkedin.png"
                    alt="LinkedIn"
                    className="linkedin-icon"
                    loading="lazy"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Blogs Section */}
      <div className="mt-4">
        <div className="col-11 m-auto text-start">
          <p className="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p className="fs-1 fw-semibold" data-aos="fade-up">
            The latest from{" "}
          </p>
          <p className="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default About;
